import { gsap, Power2 } from 'gsap'

let blockElements = '.main-menu .block-footer, .main-menu .block-button, .menu-info-column .block-content'

function showMenuContent()
{
  gsap.to(blockElements, {
    duration: 0.3,
    autoAlpha: 1,
    y: 0,
    ease: Power2.easeInOut,
  })
}

function menuOpenAnimation()
{
  gsap.set('.main-menu .menu-item', {autoAlpha: 0, y: 10})
  gsap.set(blockElements, {autoAlpha: 0, y: 10})
  gsap.set('.main-menu-container', {opacity: 1})

  gsap.to('.main-menu .menu-item',
  {
          delay: 0.4,
          duration: 0.4,
          autoAlpha: 1,
          y: 0,
          stagger: 0.2,
          ease: Power2.easeInOut,
          onComplete: showMenuContent
        }
      );
}

export { menuOpenAnimation }

